import { css } from "styled-components";
import { CarouselControls, CarouselSlide, Carousel, CarouselProgressBar, CarouselSlides, } from "../../../../components/Carousel";
import { body5TypographyMixin, body2TypographyMixin } from "../../../../skins/rg-product-pages/mixins/typography";
import { ThumbnailBorder, ThumbnailLabel } from "../../components/LandingMediaCarousel";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, palette) => css `
  --carousel-n-up: 5;
  --carousel-gap: ${chroma.spacers.variable.s};
  --carousel-gap-count: calc(var(--carousel-n-up) - 1);

  & {
    background-color: ${palette.bladebg1};
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
  }

  .media-viewport {
    background-color: ${palette.keyline};

    .viewport-inner {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .main-media {
      object-fit: contain;
    }
  }

  .heading {
    ${body2TypographyMixin}
    font-weight: bold;
    color: ${palette.bladetext1};
  }

  .description {
    ${body5TypographyMixin}
    color: ${palette.bladetext1};
  }

  .separator {
    display: none;
    border: 1px solid ${palette.keyline};
    margin: ${chroma.spacers.constant.s} 0;
  }

  ${Carousel} {
    padding-top: ${chroma.spacers.constant.s};

    &[data-state-all-slides-visible="true"] {
      ${CarouselControls} {
        display: none;
      }

      .separator {
        display: block;
      }

      ${CarouselSlides} {
        justify-content: center;
      }
    }
  }

  ${CarouselSlides} {
    gap: var(--carousel-gap);
  }

  ${ThumbnailBorder} {
    padding: ${chroma.spacers.constant.xxxs};
    margin-bottom: ${chroma.spacers.variable.s};
  }

  ${ThumbnailLabel} {
    color: ${palette.accents1};
    text-align: center;
    ${chroma.typography.body5}
    font-weight: 500;
    ${textUppercaseMixin};
  }

  ${CarouselSlide} {
    cursor: pointer;
    box-sizing: border-box;

    &[data-slide-active="false"] {
      ${ThumbnailBorder} {
        border: 2px solid transparent;
      }

      ${ThumbnailLabel} {
        color: #999;
      }
    }

    &[data-slide-active="true"] {
      ${ThumbnailBorder} {
        border: 1px solid ${palette.accents1};
      }
    }

    ${chroma.mediaQueries.mobileDown} {
      --carousel-n-up: 4;
    }

    --slide-width: calc((100% - (var(--carousel-gap) * (var(--carousel-n-up) - 1))) / var(--carousel-n-up));

    min-width: var(--slide-width);
    width: var(--slide-width);
  }

  ${CarouselControls} {
    padding: ${chroma.spacers.constant.s} 0;
    gap: ${chroma.spacers.constant.s};
    display: flex;
  }

  ${CarouselProgressBar} {
    width: auto;
    flex-grow: 1;
    padding-right: 0;
    align-self: center;

    .indicator {
      transition: width 0.7s ease-out;
      background-color: ${palette.accents1};
    }

    .rail {
      background-color: ${palette.keyline};
      margin-top: 0;
      width: 100%;
    }
  }

  .trigger-wrapper {
    display: flex;
    gap: ${chroma.spacers.constant.xs};
  }
`;
//# sourceMappingURL=index.js.map